import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const rsae = 'Admin-rsae'
const rsan = 'Admin-rsan'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function getRSAE() {
  return Cookies.get(rsae)
}

export function setRSAE(val) {
  return Cookies.set(rsae, val)
}

export function getRSAN() {
  return Cookies.get(rsan)
}

export function setRSAN(val) {
  return Cookies.set(rsan, val)
}

export function setCookie(key,val) {
  return Cookies.set(key,val)
}

export function getCookie(key) {
  return Cookies.get(key)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
